import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'

export type GamificationRulesSummaryResponse = {
  data: { hasWalletRewards: boolean }
  object: 'gamification_rules_summary'
}

export const getGamificationRulesSummary: QueryFn<['getGamificationRulesSummary'], boolean> = async client => {
  const { data, status } = await client.get<GamificationRulesSummaryResponse>('v1/partner/gamification/rules/summary', {
    validateStatus: code => [200, 403].includes(code)
  })

  return status === 200 ? data.data.hasWalletRewards : false
}
